import { gql } from '@apollo/client/core';

export const LOGIN = gql`
  mutation login($username: String!, $password: String!) {
    login(username: $username, password: $password) {
      token
      tokenDuration
      tokenExpirationDate
      refreshToken
      cashbackReminder
      requiresTwoFactor
      temporaryToken
      user {
        email
        phoneNumber
        id
        lastname
        firstname
        countActiveOrganizations
        mainPack
        uniqId
        lastTutorialCompletionDate
      }
    }
  }
`;

/**
 * Deuxième étape de connexion, quand le compte est protégé par un second facteur : le
 * jeton temporaire rendu par `login` est échangé contre la paire habituelle. Le code
 * accepté est celui de l'application d'authentification ou un code de secours.
 */
export const LOGIN_TWO_FACTOR = gql`
  mutation loginTwoFactor($temporaryToken: String!, $code: String!) {
    loginTwoFactor(temporaryToken: $temporaryToken, code: $code) {
      token
      tokenDuration
      tokenExpirationDate
      refreshToken
      cashbackReminder
      user {
        email
        phoneNumber
        id
        lastname
        firstname
        countActiveOrganizations
        mainPack
        uniqId
        lastTutorialCompletionDate
      }
    }
  }
`;

export const REFRESH_TOKEN = gql`
  mutation refreshToken($refreshToken: String!, $username: String!) {
    refreshToken(refreshToken: $refreshToken, username: $username) {
      token
      tokenDuration
      tokenExpirationDate
      refreshToken
      user {
        email
        phoneNumber
        id
        lastname
        firstname
        countActiveOrganizations
        mainPack
        uniqId
        lastTutorialCompletionDate
      }
    }
  }
`;

export const FORGOT_PASSWORD = gql`
  mutation forgotPassword($username: String!) {
    forgotPassword(username: $username) {
      success
      message
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($userId: Int!, $data: UserInput) {
    updateUser(userId: $userId, data: $data) {
      id
      email
      phoneNumber
      lastname
      firstname
      lastTutorialCompletionDate
    }
  }
`;
